"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browser_tracker_1 = require("@snowplow/browser-tracker");
var minimumVisitLength = 30;
var heartbeatDelay = 10;
/**
 * Enables the Activity Tracking plugin with custom configuration
 */
var enableActivityTrackingWithConfig = function enableActivityTrackingWithConfig() {
  (0, browser_tracker_1.enableActivityTracking)({
    minimumVisitLength: minimumVisitLength,
    heartbeatDelay: heartbeatDelay
  });
};
exports["default"] = enableActivityTrackingWithConfig;